/**
 * Finish an in-place sign-in (sc-7039), shared across cabinets (sc-7065).
 *
 * The redirect flows (magic-link, OAuth) land on /auth/callback, which
 * sets the session + claims anonymous scores. Email-OTP verifies IN PLACE
 * (no redirect) — the wall calls this to do the same two steps from an
 * AuthSessionResponse it just received.
 *
 * The score-claim needs two APP-SPECIFIC functions (each cabinet has its
 * own api/client + device identity), so they're INJECTED rather than
 * imported — this keeps the package free of any per-app path.
 */
import { setSession } from './session.js';
/**
 * Persist the session, then fire the anonymous-score claim (fire-and-
 * forget + idempotent — never block or fail sign-in on it).
 */
export function establishSession(resp, deps) {
    setSession({
        accessToken: resp.accessToken,
        refreshToken: resp.refreshToken,
        expiresAt: Date.now() + resp.expiresIn * 1000,
        email: resp.email,
        userId: resp.userId,
    });
    void deps
        .claimAnonymousScores({ deviceId: deps.getOrCreateDeviceId() })
        .then((result) => {
        if (result.claimed > 0) {
            console.info('[arcadia84] claimed anonymous scores', { claimed: result.claimed });
        }
    })
        .catch((err) => {
        console.warn('[arcadia84] claim-anonymous-scores failed', { err });
    });
}
//# sourceMappingURL=establish.js.map